import React from 'react'
import { PlaceholderWrapper, Placeholder } from '../GameBoardStyles'
import { CardFront } from '../../card/CardFront'
import { calculateDelay } from '../../card/helpers/calculateDelay'
import { colors } from '../../../lib/colors'

export default function River({
  card,
  deal,
  dealOut,
  winPositions,
  showResult,
}: any) {
  return (
    <Placeholder zIndex={0}>
      <CardFront
        card={card}
        deal={deal}
        dealOut={dealOut}
        animDelay={calculateDelay(0)}
        background={
          showResult && winPositions === '1'
            ? colors.secondary
            : colors.cardWhite
        }
      />
    </Placeholder>
  )
}
